import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { motion, AnimatePresence } from "framer-motion";
import { FiSun, FiMoon } from "react-icons/fi";

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  // Variants for icon animations
  const iconVariants = {
    initial: { opacity: 0, y: -10, rotate: -45 },
    animate: { opacity: 1, y: 0, rotate: 0, transition: { duration: 0.3 } },
    exit: { opacity: 0, y: 10, rotate: 45, transition: { duration: 0.3 } },
  };

  // Ripple effect for button
  const buttonVariants = {
    hover: {
      scale: 1.05,
      boxShadow: "0px 0px 8px rgba(255, 255, 255, 0.3)",
    },
    tap: {
      scale: 0.95,
    },
  };

  return (
    <motion.button
      className="p-2 !rounded-full w-10 h-10 bg-[color:var(--accent)]/10 text-[color:var(--accent)] flex items-center justify-center relative overflow-hidden"
      onClick={toggleTheme}
      variants={buttonVariants}
      whileHover="hover"
      whileTap="tap"
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      {/* Background pulse effect on toggle */}
      {theme === "dark" ? (
        <motion.div
          key="dark-ripple"
          initial={{ scale: 0, opacity: 0.8 }}
          animate={{ scale: 1.5, opacity: 0 }}
          transition={{ duration: 0.8 }}
          className="absolute w-full h-full rounded-full bg-yellow-500/40"
        />
      ) : (
        <motion.div
          key="light-ripple"
          initial={{ scale: 0, opacity: 0.8 }}
          animate={{ scale: 1.5, opacity: 0 }}
          transition={{ duration: 0.8 }}
          className="absolute w-full h-full rounded-full bg-blue-900/40"
        />
      )}

      {/* Icon animation */}
      <AnimatePresence mode="wait">
        {theme === "dark" ? (
          <motion.div
            key="moon"
            variants={iconVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <FiMoon className="w-5 h-5 text-[color:var(--accent)]" />
          </motion.div>
        ) : (
          <motion.div
            key="sun"
            variants={iconVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <FiSun className="w-5 h-5 text-[color:var(--color-light)]" />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.button>
  );
};

export default ThemeToggle;
